export const modules = [
  { value: "module01", label: "Modul 1" },
  { value: "module02", label: "Modul 2" },
  { value: "module03", label: "Modul 3" },
  { value: "module04", label: "Modul 4" },
  { value: "module05", label: "Modul 5" },
  { value: "module06", label: "Modul 6" },
  { value: "module07", label: "Modul 7" },
  { value: "module08", label: "Modul 8" },
];

export const difficulties = [
  { value: "beginner", label: "Nybegynner" },
  { value: "medium", label: "Middels" },
  { value: "advanced", label: "Avansert" },
];

export const clinicalCategories = [
  { value: "acute", label: "Akutt" },
  { value: "chronic", label: "Kronisk" },
  { value: "preventive", label: "Forebyggende" },
];
